import { render, staticRenderFns } from "./boas-vindas-falada.vue?vue&type=template&id=180b0134&scoped=true&"
import script from "./boas-vindas-falada.vue?vue&type=script&lang=js&"
export * from "./boas-vindas-falada.vue?vue&type=script&lang=js&"
import style0 from "./boas-vindas-falada.vue?vue&type=style&index=0&id=180b0134&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180b0134",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFadeTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VFadeTransition})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('180b0134')) {
      api.createRecord('180b0134', component.options)
    } else {
      api.reload('180b0134', component.options)
    }
    module.hot.accept("./boas-vindas-falada.vue?vue&type=template&id=180b0134&scoped=true&", function () {
      api.rerender('180b0134', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/aawz-intelligence-v2/components/boas-vindas-falada/boas-vindas-falada.vue"
export default component.exports